import { render } from "./App.vue?vue&type=template&id=821b8620"
const script = {}

import "./App.vue?vue&type=style&index=0&id=821b8620&lang=scss"
import "./App.vue?vue&type=style&index=1&id=821b8620&rel=stylesheet%2Fscss&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__